module.exports = __webpack_public_path__ + "static/media/ic_access_alarms_24px_red.f29840a3.svg";